import { render, staticRenderFns } from "./FormFieldsText.vue?vue&type=template&id=0f30745a&"
import script from "./FormFieldsText.vue?vue&type=script&lang=js&"
export * from "./FormFieldsText.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldsText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
